import Vue from "vue";
import VueI18n from "vue-i18n";
import Cookies from "js-cookie";
import elementEnLocale from "element-ui/lib/locale/lang/en";
import elementZhLocale from "element-ui/lib/locale/lang/zh-CN";
import elementEsLocale from "../assets/es";
import enLocale from "./en";
import zhLocale from "./zh";
import esLocale from "./es";
import local from "element-ui/lib/locale"

Vue.use(VueI18n);

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  },
  es: {
    ...esLocale,
    ...elementEsLocale
  },

};
export function getLanguage() {
  const chooseLanguage = localStorage.getItem('lang')
  if (chooseLanguage) return chooseLanguage;
  const language = (navigator.language || navigator.browserLanguage).toLowerCase(); //获取浏览器的语言
  const locales = Object.keys(messages);
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale;
    }
  }
  return "en";
}
export function getLang(){
  return  localStorage.getItem('lang')
}
const i18n = new VueI18n({
  locale: getLanguage(),
  messages
});
local.i18n((key,value)=>i18n.t(key,value))

export default i18n;
